import options from './recent-events.component';

export default {
    selector: 'dtRecentEvents',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/recent-events/index.js